import clone from 'lodash/clone'
import { parseNumber } from './parse-number'

// Old add using Math.ceil. V3 changed to new
export function oldAdd(dst: any, src: any) {
  const result = clone(dst)

  for (const key in src) {
    if (typeof src[key] === 'object' && src[key] !== null) {
      result[key] = clone(src[key])
    } else {
      const srcVal = parseNumber(src[key])

      if (!Number.isNaN(srcVal)) {
        const dstVal = parseNumber(result[key])
        const sum = Math.ceil((dstVal + srcVal) * 100) / 100

        if (!Number.isNaN(sum)) {
          result[key] = sum
        }
      }
    }
  }

  return result
}
